import { takeEvery } from "redux-saga/effects";
import * as TYPES from "./type";
import * as authSaga from "./saga";

export function* watchAuthCurrent() {
  yield takeEvery(TYPES.AUTH_CURRENT_REQ, authSaga.userAuthCurrentAction);
}

export function* watchLoginGoogle() {
  yield takeEvery(TYPES.AUTH_LOGIN_GOOGLE_REQ, authSaga.userLoginGoogleAction);
}

export function* watchLogoutGoogle() {
  yield takeEvery(
    TYPES.AUTH_LOGOUT_GOOGLE_REQ,
    authSaga.userLogoutGoogleAction
  );
}
